import events from '@wh/quick-deposit/es/main/events';

import { publish, subscribe } from '../patched-message-bus';
import { DEPOSIT, QUICK_DEPOSIT } from './constants';
import { commandClose } from './message-bus-helpers/commandClose';
import { commandOpen } from './message-bus-helpers/commandOpen';
import { onEventClosed } from './message-bus-helpers/eventClosed';
import { onEventFailed } from './message-bus-helpers/eventFailed';
import { onEventOpened } from './message-bus-helpers/eventOpened';
import { onEventRequested } from './message-bus-helpers/eventRequested';

// 'modal_clos' is sent on mobile, 'modal_close' is sent on desktop (there is no typo)
var OPENBET_MODAL_CLOSE_EVENTS = ['modal_clos', 'modal_close', 'modal_close_without_reload'];

var listenToModalClose = function listenToModalClose(_ref) {
  var data = _ref.data;

  if (OPENBET_MODAL_CLOSE_EVENTS.includes(data)) {
    publish(commandClose({ type: DEPOSIT }));
  }
};

export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var useGlobal = typeof options.disableQuickDeposit !== 'undefined';
  subscribe(onEventRequested(function () {
    var eventData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var closeOnSuccess = eventData.closeOnSuccess,
        eventSource = eventData.eventSource,
        submitTextKey = eventData.submitTextKey,
        pmtSource = eventData.pmtSource;

    var disableQuickDeposit = useGlobal ? options.disableQuickDeposit : eventData.disableQuickDeposit;
    publish(commandOpen({
      closeOnSuccess: closeOnSuccess,
      eventSource: eventSource,
      submitTextKey: submitTextKey,
      type: disableQuickDeposit ? DEPOSIT : QUICK_DEPOSIT,
      pmtSource: pmtSource
    }));
  }));

  var switchFromQuickDepositToDeposit = function switchFromQuickDepositToDeposit() {
    publish(commandClose({ type: QUICK_DEPOSIT }));
    publish(commandOpen({ type: DEPOSIT }));
  };

  var handleQuickDepositFailedEvent = function handleQuickDepositFailedEvent(_ref2) {
    var code = _ref2.code;

    if (code !== 'PAYMENT') {
      switchFromQuickDepositToDeposit();
    }
  };

  subscribe(events.MESSAGE_PUB_QD_OPEN_DEPOSIT, switchFromQuickDepositToDeposit);
  subscribe(onEventFailed(handleQuickDepositFailedEvent));

  subscribe(onEventOpened(function () {
    window.addEventListener('message', listenToModalClose, false);
  }));
  subscribe(onEventClosed(function () {
    window.removeEventListener('message', listenToModalClose, false);
  }));
});
//# sourceMappingURL=depositWorkflow.js.map